"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookies = exports.getUserAgent = exports.getHostname = exports.getHref = exports.getOrigin = exports.getSearchString = exports.runInServer = exports.isSSR = exports.updateStore = exports.getSnapshootByKey = exports.getSnapshoot = void 0;
var SSRStore = {
    countryCode: "",
    languageCode: "",
    currencyCode: "",
    platform: "",
    hostname: "",
    api: "",
    userAgent: "",
    origin: "",
    href: "",
    search: "",
    id: "",
    cookies: "",
    customerId: ""
};
function getSnapshoot() {
    return SSRStore;
}
exports.getSnapshoot = getSnapshoot;
function getSnapshootByKey(key) {
    return SSRStore[key];
}
exports.getSnapshootByKey = getSnapshootByKey;
function updateStore(params) {
    for (var p in params) {
        if (params.hasOwnProperty(p)) {
            SSRStore[p] = params[p];
        }
    }
}
exports.updateStore = updateStore;
function isSSR() {
    return __SSR__;
}
exports.isSSR = isSSR;
function runInServer() {
    return typeof window === "undefined";
}
exports.runInServer = runInServer;
function getSearchString() {
    return runInServer() ? getSnapshootByKey("search") : window.location.search;
}
exports.getSearchString = getSearchString;
function getOrigin() {
    return runInServer() ? getSnapshootByKey("origin") : window.location.origin;
}
exports.getOrigin = getOrigin;
function getHref() {
    return runInServer() ? getSnapshootByKey("href") : window.location.href;
}
exports.getHref = getHref;
function getHostname() {
    return runInServer() ? getSnapshootByKey("hostname") : window.location.hostname;
}
exports.getHostname = getHostname;
function getUserAgent() {
    return runInServer() ? getSnapshootByKey("userAgent") : window.navigator.userAgent;
}
exports.getUserAgent = getUserAgent;
function getCookies() {
    return runInServer() ? getSnapshootByKey("cookies") : null;
}
exports.getCookies = getCookies;
